import { render, staticRenderFns } from "./EmptyResult.vue?vue&type=template&id=45497082&scoped=true"
import script from "./EmptyResult.vue?vue&type=script&lang=ts"
export * from "./EmptyResult.vue?vue&type=script&lang=ts"
import style0 from "./EmptyResult.vue?vue&type=style&index=0&id=45497082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45497082",
  null
  
)

export default component.exports